import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// Define a type for the slice state
interface driverInfoState {
    referenceId: string;
    orgId: string;
    driverName: string;
    driverId: string;
    submittedName: string;
    phoneNumber: string;
    submittedPhoneNumber: string;
    submittedCarrierName: string;
    submittedCarrierScac: string;
    trailerLength: string;
    trailerType: string;
    cabType: string;
    deliveryId: string;
    language: string;
    laneNo: string;
    trailerNumber: string;
    licensePlateNumber: string;
    didQueryReturnTrailerNumber: boolean;
    customerPo: string;
    tripId: string;
    visitType: string;
    carrierSCAC: string;
    carrierName: string;
    customerName: string;
    address: string;
    dotNumber: string;
    driverConfirmedTrailerInfo: boolean;
    isOffsite: boolean;
}

// Define the initial state using that type
const initialState: driverInfoState = {
    referenceId: '',
    orgId: '',
    driverName: '',
    driverId: '',
    submittedName: '',
    phoneNumber: '',
    submittedPhoneNumber: '',
    submittedCarrierName: '',
    submittedCarrierScac: '',
    trailerLength: '',
    trailerType: '',
    cabType: '',
    deliveryId: '',
    language: '',
    laneNo: '',
    trailerNumber: '',
    licensePlateNumber: '',
    didQueryReturnTrailerNumber: false,
    customerPo: '',
    tripId: '',
    visitType: '',
    carrierSCAC: '',
    carrierName: '',
    customerName: '',
    address: '',
    dotNumber: '',
    driverConfirmedTrailerInfo: false,
    isOffsite: true
};

export const driverInfoSlice = createSlice({
    name: 'driverInfo',
    initialState,
    reducers: {
        saveDriverInfo: (state, action: PayloadAction<driverInfoState>) => {
            state.referenceId = action.payload.referenceId;
            state.orgId = action.payload.orgId;
            state.driverName = action.payload.driverName;
            state.driverId = action.payload.driverId;
            state.submittedName = action.payload.submittedName;
            state.phoneNumber = action.payload.phoneNumber;
            state.submittedPhoneNumber = action.payload.submittedPhoneNumber;
            state.submittedCarrierName = action.payload.submittedCarrierName;
            state.submittedCarrierScac = action.payload.submittedCarrierScac;
            state.trailerLength = action.payload.trailerLength;
            state.trailerType = action.payload.trailerType;
            state.cabType = action.payload.cabType;
            state.deliveryId = action.payload.deliveryId;
            state.language = action.payload.language;
            state.laneNo = action.payload.laneNo;
            state.trailerNumber = action.payload.trailerNumber;
            state.licensePlateNumber = action.payload.licensePlateNumber;
            state.didQueryReturnTrailerNumber = action.payload.didQueryReturnTrailerNumber;
            state.customerPo = action.payload.customerPo;
            state.tripId = action.payload.tripId;
            state.visitType = action.payload.visitType;
            state.carrierSCAC = action.payload.carrierSCAC;
            state.carrierName = action.payload.carrierName;
            state.customerName = action.payload.customerName;
            state.address = action.payload.address;
            state.dotNumber = action.payload.dotNumber;
            state.driverConfirmedTrailerInfo = action.payload.driverConfirmedTrailerInfo;
            state.isOffsite = action.payload.isOffsite;
        }
    }
});

// Action creators are generated for each case reducer function
export const { saveDriverInfo } = driverInfoSlice.actions;

export default driverInfoSlice.reducer;
